import { cacheDom } from "../utils/QuerySelectors.js"
import { toggleModal } from "../components/Popup.js"

const dom = {}
const qs = {
  showcasePopup: 'data-showcase-popup',
  showcaseSwiper: 'data-showcase-media',
  modal: 'data-popup',
}
const qsAll = {
  sections: 'data-section-type="media-grid"',
  showcases: 'data-showcase',
}

const initShowcasePopup = (showcase) => {
  const popupContent = showcase.querySelector(`[${qs.showcasePopup}]`)
  toggleModal(true, popupContent.innerHTML, null, true)
  new Swiper(dom.modal.querySelector(`[${qs.showcaseSwiper}]`), {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
  window.setupProductTiles(dom.modal.querySelectorAll('[product-tile]:empty'))
}

const initSection = (section) => {
  const showcases = section.querySelectorAll(`[${qsAll.showcases}]`)
  
  showcases.forEach(showcase => {
    showcase.addEventListener('click', () => {
      initShowcasePopup(showcase)
    })
  })
}

export const setupMediaGrid = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}